import { render } from "./CounselorsSvg.vue?vue&type=template&id=0a8c09f7"
const script = {}
script.render = render

export default script